import InputText from '../primevue/inputtext/index'
import Button from '../primevue/button/index'
import AutoComplete from '../primevue/autocomplete'
import Tabs from './tabs'
import TabList from './tablist'
import Tab from './tab'
import Select from './select'
import Toast from './toast'
import Dialog from './dialog'

export default {
  InputText,
  Button,
  AutoComplete,
  Tabs,
  TabList,
  Tab,
  Select,
  Toast,
  Dialog,
}
